<p>installation-payment-method works!</p>
